import React, { useState, useEffect } from 'react';
import styles from './styles.module.scss';

const TreeItemForm = ({ item, onSubmit, onClose, title }) => {
  const [formData, setFormData] = useState({
    title: '',
    title_index: '',
    description: '',
  });

  useEffect(() => {
    if (item) {
      setFormData({
        title: item.title || '',
        title_index: item.title_index || '',
        description: item.description || '',
      });
    }
  }, [item]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (!formData.title.trim()) return;
    onSubmit(formData);
  };

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.modalOverlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <h2 className={styles.modalTitle}>{title}</h2>

        <form onSubmit={handleSubmit}>
          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Индекс (нумерация)</label>
            <input
              type="text"
              name="title_index"
              className={styles.formInput}
              value={formData.title_index}
              onChange={handleChange}
              placeholder="Например: 1.1"
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Наименование *</label>
            <input
              type="text"
              name="title"
              className={styles.formInput}
              value={formData.title}
              onChange={handleChange}
              placeholder="Введите наименование"
              required
            />
          </div>

          <div className={styles.formGroup}>
            <label className={styles.formLabel}>Описание</label>
            <textarea
              name="description"
              className={styles.formTextarea}
              value={formData.description}
              onChange={handleChange}
              placeholder="Введите описание (необязательно)"
            />
          </div>

          <div className={styles.modalActions}>
            <button type="button" className={styles.cancelButton} onClick={onClose}>
              Отмена
            </button>
            <button
              type="submit"
              className={styles.submitButton}
              disabled={!formData.title.trim()}
            >
              Сохранить
            </button>
          </div>
        </form>
      </div>
    </div>
  );
};

export default TreeItemForm;
